import { sessionPrefix } from "./helpers";

export const punchlistPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/punchlist`;
export const newPunchlistEntryPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/punchlist/new`;
export const showPunchlistEntryPath = (session: LightSessionInterface, entry: PunchlistEntryDetail) =>
  `${sessionPrefix(session)}/punchlist/${entry.id}`;
